import React, { memo } from 'react'
import { Droppable, Draggable } from 'react-beautiful-dnd'
import { withStyles } from '@material-ui/core/styles'

import ColumnHeader from './ColumnHeader'
import ColumnItem from './ColumnItem'

import style from './style'

function PipelineColumn({ items, stage, classes, getActionsCard }) {
  return (
    <Droppable droppableId={stage}>
      {(provided, snapshot) => (
        <div ref={provided.innerRef} className={classes.list}>
          <ColumnHeader stage={stage} items={items} count={items.length} />
          {items.map((item, index) => (
            <Draggable
              key={item.id}
              draggableId={item.id}
              index={index}
              isDragDisabled={true}
            >
              {(provided, snapshot) => (
                <ColumnItem
                  provided={provided}
                  snapshot={snapshot}
                  item={item}
                  stage={stage}
                  getActionsCard={getActionsCard}
                />
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  )
}

export default memo(withStyles(style)(PipelineColumn))
